<template>
  <div class="version-display" v-if="version">
    v{{ version }}
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';

export default {
  name: 'VersionDisplay',
  setup() {
    const version = ref(null);
    
    onMounted(async () => {
      try {
        const response = await axios.get('/version.json?t=' + new Date().getTime());
        if (response.data && response.data.version) {
          version.value = response.data.version;
        }
      } catch (error) {
        
      }
    });
    
    return {
      version
    };
  }
}
</script>

<style scoped>
.version-display {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 0.75rem;
  opacity: 0.6;
  color: var(--text-color);
  font-family: monospace;
}
</style>
